import { SUBSCRIPTION_LIMITATIONS, SubscriptionType } from '../dto/subscription.dto';
import { formatBigNumber } from './number.utils';

export function getSubscriptionFeatures(subscriptionType: SubscriptionType): string[] {
  const limitations = SUBSCRIPTION_LIMITATIONS[subscriptionType];

  switch (subscriptionType) {
    case SubscriptionType.Free:
      return [
        limitations.monthlyActiveUsers + ' Monthly Active Users',
        'Hints & Tooltips',
        'Announcements',
        'Banners',
        'Popups',
        'Forms',
        'Surveys',
        'Checklists',
        limitations.maxKnowledgeBaseCount + ' Knowledge Base',
        limitations.maxArticleCount + ' Articles',
        'Custom elements',
        'Unlimited websites',
        'Unlimited members',
      ];
    case SubscriptionType.Enterprise:
      return [
        'SAML & SSO',
        'Enterprise reports',
        'Custom features',
        'Custom integrations',
        'VIP support',
      ];
    default:
      return [
        `${ formatBigNumber(limitations.monthlyActiveUsers || 0) } Monthly Active Users`,
        'Custom Domains',
        'Unlimited Knowledge Bases',
        'Unlimited Articles',
        'Form Notifications',
      ];
  }
}